<template>
  <div class="popup__box" :class="getPopOverClass()">
    <slot />
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    error: {
      type: Boolean,
      default () {
        return false
      }
    }
  })

  const getPopOverClass = () => {
    if (props.error) {
      return 'popup__box--error'
    }
    return ''
  }
</script>
